import { FC } from 'react';

import { Badge } from '@purpur/library';
import { IconDelivery } from '@purpur/library/icon/delivery';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import { CellPrice, DeliveryEntryCellTitle, DeliveryEntryListItem } from './entries.styles';

type DeliveryEntryProps = {
    price: Price;
};

export const DeliveryEntry: FC<DeliveryEntryProps> = ({ price }) => {
    const { t } = useTranslations();
    const isFree = price?.value === 0;
    const title = t['order_cart.entry_delivery.title'];

    return (
        <DeliveryEntryListItem data-test={ORDER_CART_ENTRY_ID.DELIVERY} aria-label={title}>
            <IconDelivery size="md" />
            <DeliveryEntryCellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_DELIVERY}>
                {title}
                {isFree && <Badge variant="special">{t['order_cart.entry_delivery.badge']}</Badge>}
            </DeliveryEntryCellTitle>
            <CellPrice price={price} dataTest={ORDER_CART_TEST_ID.PRICE_DELIVERY} />
        </DeliveryEntryListItem>
    );
};
